import React, { Component } from 'react';
import service from '../../core/service';
import * as yup from 'yup'
import { fixNumbers, numberWithCommas, parsePersianDate, toFarsiNumber } from '../../core/utils';
import { isEqual, universalDataa, userData } from '../../Redux/services/generalService';
import { toast } from 'react-toastify';
import axios from 'axios';
import { AppConstants } from '../../core/constants';
import Cookies from 'js-cookie';

interface IProps {
  dispatch?: any,
  userData?:any;

}

interface IState {
  value:any;
  step:number;
  currentPage: number,
  result: any;
  data?: any;
  options?: any,
  projectDetails?:any;
  limitationInquiry: any;
  allLimitationInquiry: any;
  contract_id: any;
  contractList: any;
  premium_annually: string;
  adjustment_coefficient_death_benefit:string;
  start_death_asset: string;
  errors:any;
  holder_birthday: any;
  insured_birthday: any;
  selfsame: boolean;
  policy_holder_job_category: string;
  insured_job_category: string;

  policy_holder_job_category_title: string;
  insured_job_category_title: string;
  jobListInquiryLoading: boolean;
  jobListInquiry: any;
  jobListHolder: any;
  jobListHolderLoading: boolean;
  tab:number;
  showInfo:boolean,
  contractSelected:string;
  contractNumberErrors:any;
  contentLoading: boolean;
  base64Loading:boolean;
  settings:any;
  tabValue:number;
  loading:boolean;
  doucument:any;
  openMenu: boolean;
  isEdited?: boolean;
  openModal:boolean;
  modalLabel?:string;
  modalNotice?:string;
  step1Errors: any,
  minimum_insurance_premium:string; 
  
}

export class UniversalController extends Component<IProps, IState> {
  datePickerRefHolder: any;
  datePickerRefInsured: any;


  constructor(props: any) {
    super(props);
    this.datePickerRefHolder = React.createRef();
    this.datePickerRefInsured = React.createRef();
  }


  state: IState = {
    value:"0.1",
    step:1,
    currentPage: 0,
    tabValue:0,
    result: [],
    data: {
      labels: [],
      datasets: [

      ]
    },
    selfsame: false,

    options: {

    },
    projectDetails:[],
  limitationInquiry: [],
  allLimitationInquiry: [],
  contract_id: "",
  contractList: [],
  premium_annually: "",
  adjustment_coefficient_death_benefit:"",
  start_death_asset: "",
  errors:[],
  insured_birthday:"",
  holder_birthday:parsePersianDate(this.props.userData?.birthdate) || "",

  policy_holder_job_category: "",
  insured_job_category: "",

  policy_holder_job_category_title: "",
  insured_job_category_title: "",
  jobListInquiryLoading: false,
  jobListInquiry: [],
  jobListHolder: [],
  jobListHolderLoading: false,
  tab:0,
  showInfo:false,
  contractSelected:"0",
  contractNumberErrors:[],
  contentLoading: false,
  base64Loading:false,
  loading:true,
  doucument:[],
  settings: {
    infinite: false,
    dots: true,
    centerMode: false, 
    speed: 500,
    slidesToShow: 1, 
    slidesToScroll: 1,
    adaptiveHeight: true,
    rtl: true,
    arrows: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        },
      },
    ],
  },
  openMenu: false,
  isEdited: false,
  openModal:false,
  modalLabel:"",
  modalNotice:"",
  step1Errors: [],
  minimum_insurance_premium:"",

  };

   handleSliderChange = (event: any) => {
    this.setState({ value: event.target.value })

  };


  async checkStep2 () {
  const { value , contract_id , premium_annually} = this.state;
  const shebaCodeSchema = yup.object({

    value: yup.string()
    .required("متراژ اجباری می باشد")
    .test("value", `  نمیتواند کمتر از ${this.findMinLimitation("unit_count")}  و بیشتر از ${this.findMaxLimitation("unit_count")}  باشد `,
      (value) => {
        if (Number(value) < this.findMinLimitation("unit_count") || Number(value) > this.findMaxLimitation("unit_count")) {
          return false;
        } else {
          return true
        }

      }),
      premium_annually: yup.string()
    .required("مبلغ سرمایه گذاری اجباری می باشد")
    .test("premium_annually", `  نمیتواند کمتر از ${this.findMinLimitation("premium_annually")} ریال و بیشتر از ${this.findMaxLimitation("premium_annually")} ریال باشد `,
      (premium_annually) => {
        if (Number(premium_annually) < this.findMinLimitation("premium_annually") || Number(premium_annually) > this.findMaxLimitation("premium_annually")) {
          return false;
        } else {
          return true
        }

      }),

    
        contract_id: yup.string().when('$condition', (condition, schema) =>
          contract_id !== "" ?
            schema.required("شماره قرارداد اجباری می‌باشد").min(3, "شماره قرارداد نمی‌تواند کمتر از 3 کاراکتر باشد").max(10, "شماره قرارداد نمی‌تواند بیشتر از 10 کاراکتر باشد") : schema
        ),
  
  });
  try {
    await shebaCodeSchema.validate({ value , contract_id , premium_annually }, { abortEarly: false });
    // if(this.state.isEdited){
      this.setState({step:this.state.step + 1 , step1Errors:[]})
    // }
      // else{this.getLimitationInquery();}
    // this.setState({ start_death_asset: (this.state.projectDetails.available_price * value).toFixed(0) , premium_annually : (this.state.projectDetails.available_price * value).toFixed(0)})
  // if(this.state.isEdited){
  //   this.setState({step:this.state.step + 1})
  //   } else {
  //     this.getLimitationInquery();
  //     this.setState({ 
  //       start_death_asset: (this.state.projectDetails.available_price * value).toFixed(0),
  //     })
  //   }
  //   this.setState({ 
  //     premium_annually: (this.state.projectDetails.available_price * value).toFixed(0)
  //   })
  } catch (err: any) {
        this.setState({ step1Errors: err.inner })
        // toast.error(err.inner[0].message);

    
  }
   }
  //  handleBlur = () => {
  //   if (this.state.value < 0) {
  //   this.setState({ value: 0 })
  //   } else if (this.state.value > this.state.projectDetails?.units_all) {
  //   this.setState({ value: this.state.projectDetails?.units_all })
      
  //   }
  // };

  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({
      currentPage: Number(value - 1)
    });

  }
  searchTimeout: string | number | NodeJS.Timeout | undefined;
  getJobInquiry = (e: any) => {
    this.setState({ jobListInquiryLoading: true })
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(async () => {
      try {
        const response = await service.limitationInquiry.job(e);
        if (response) {
          this.setState({ jobListInquiry: response.data.data?.data?.list, jobListInquiryLoading: false })

          // return response;
        } else {
          this.setState({ jobListInquiryLoading: false })

        }
      } catch (error) {
        // throw error;
      }
    }, 1000);
  };

  selfsame = (e: any) => {
    this.setState({ selfsame: e.target.checked })

    if (e.target.checked) {
      this.setState({
        // holder_birthday: ,
        insured_birthday: this.state.holder_birthday,
        // policy_holder_job_category,
        insured_job_category: this.state.policy_holder_job_category,
        insured_job_category_title: this.state.policy_holder_job_category_title,

        // policy_holder_extra_dangers,
      })
    } else {
      this.setState({
        insured_birthday: "",
        insured_job_category: "",
        insured_job_category_title: "",
        // insurred_extra_dangers: "",
      })
    }
  }
  searchTimeoutH: string | number | NodeJS.Timeout | undefined;
  getJobHolder = (e: any) => {
    this.setState({ jobListHolderLoading: true })
    clearTimeout(this.searchTimeoutH);
    this.searchTimeoutH = setTimeout(async () => {
      try {
        const response = await service.limitationInquiry.job(e);
        if (response) {
          this.setState({ jobListHolder: response.data.data?.data?.list, jobListHolderLoading: false })

          // return response;
        } else {
          this.setState({ jobListHolderLoading: false })

        }
      } catch (error) {
        // throw error;
      }
    }, 1000);
  };


  getDetails = async (id:string) => {
    try {
      const response = await service.HousingProject.details(id,this.state.contract_id);
      if (response) {
        this.setState({ projectDetails: response?.data?.data })
        // return response;
      }
    } catch (error) {
      // throw error;
    }
  };
  getMoreDetails= async (id:string) => {
    try {
      const response = await service.HousingProject.moreDetails(id);
      if (response) {
        this.setState({ doucument: response?.data?.data  })
  
        // return response;
      }
    } catch (error) {
      // throw error;
    }
  };
  getProfile = () => {
    this.setState({loading:true})
    return async  (dispatch: any) => {
        try {
            const response = await service.User.profile();
            if (response) {
                dispatch(userData(response?.data?.data));
                this.setState({loading:false});
                this.getTemporary(window.location.pathname.split("/")[3])

            }
        } catch (error: any) {
            this.setState({loading:false});
            if (error && error.status === 404) {
              window.location.href = '/profile-not-found'
          }
        }
    };
};
  getTemporary= async (token:string) => {
    try {
      const response = await service.HousingProject.temporary(token);
      if (response) {
        this.setState({ value: response?.data?.data?.context?.investmentValue ,
           premium_annually:response?.data?.data?.context?.investmentAmount ,
           contract_id : response?.data?.data?.context?.contract_id})
  
        // return response;
      }
    } catch (error) {
      // throw error;
    }
  };
  getLimitationInquery = async () => {
    this.setState({ contentLoading: true })

    try {

      const response =  this.state.contract_id === "" ? await service.limitationInquiry.limitation("UniversalHousing") : await service.limitationInquiry.limitation2("UniversalHousing", this.state.contract_id)
      if (response) {
        this.setState({ contentLoading: false })

        const data =  response.data.data?.data.defaults_once

        if (window.location.pathname.split("/")[3]) {
          this.setState({
            // return response;
            limitationInquiry: response.data.data?.data?.defaults_once,
            allLimitationInquiry:response.data.data?.data,
            // contract_id: response.data.data?.data?.contract_once_id,
            // return response;
            // premium_annually: data.filter((item: { name: string; }) => item.name === "premium_annually")[0]?.default,
  
            adjustment_coefficient_death_benefit: data.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.default,
            start_death_asset: data.filter((item: { name: string; }) => item.name === "start_death_asset")[0]?.default,
            // value: data.filter((item: { name: string; }) => item.name === "unit_count")[0]?.default,
            minimum_insurance_premium:data.filter((item: { name: string; }) => item.name === "minimum_insurance_premium")[0]?.default,
  
          }
          , async () => {
            
            // this.setState({step:this.state.step + 1})
            // this.getPaymentList();
            
            await this.getDetails(window.location.pathname.split("/")[2]);
            await this.getMoreDetails(window.location.pathname.split("/")[2]);
          })

        }else{
        this.setState({
          // return response;
          limitationInquiry: response.data.data?.data?.defaults_once,
          allLimitationInquiry:response.data.data?.data,
          contract_id: response.data.data?.data?.contract_once_id,
          // return response;
          premium_annually: data.filter((item: { name: string; }) => item.name === "premium_annually")[0]?.default,

          adjustment_coefficient_death_benefit: data.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.default,
          start_death_asset: data.filter((item: { name: string; }) => item.name === "start_death_asset")[0]?.default,
          value: data.filter((item: { name: string; }) => item.name === "unit_count")[0]?.default,
          minimum_insurance_premium:data.filter((item: { name: string; }) => item.name === "minimum_insurance_premium")[0]?.default,

        }
        , async () => {
          
          // this.setState({step:this.state.step + 1})
          // this.getPaymentList();
          
          await this.getDetails(window.location.pathname.split("/")[2]);
          await this.getMoreDetails(window.location.pathname.split("/")[2]);
        })
      }    
      }
    } catch (error:any) {
      this.setState({ contentLoading: false })

      if(error?.status === 400){
        toast.error("قرارداد یافت نشد")
      }
      // throw error;
    }
  };



  async createInquery() {
    const {
      contract_id,
      premium_annually,
      adjustment_coefficient_death_benefit,
      start_death_asset,
  insured_birthday,
  holder_birthday,
  policy_holder_job_category, insured_job_category,
  minimum_insurance_premium
    } = this.state;
    const shebaCodeSchema = yup.object({

    });
    try {

      await shebaCodeSchema.validate({}, { abortEarly: false });

      const response = await service.HousingProject.create({
  premium_annually,
  adjustment_coefficient_death_benefit,
  start_death_asset,
  exemption_rate : 0,
          contract_id,
          holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
          insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),
          payment_method: 0,
          available_price: this.state.projectDetails?.available_price,
          unit_request: this.state.value,
          duration: this.state.projectDetails?.duration,
          policy_holder_job_category,
           insured_job_category,
           universal_offer_id:window.location.pathname.split("/")[1] === "universal-update" ? window.location.pathname.split("/")[2] : null , 


      }
      );
      if (response) {
        this.setState({  result: response?.data?.data, step: 3 , isEdited: true})
       
        const guaranteed_reserve_array = []
        const forecast_redeem_value_array = []
        const year_array = []


        for (var i = 0; i < response?.data?.data?.result.length;  i ++) {
          guaranteed_reserve_array.push(response?.data?.data?.result[i].pre_investment);
        }


        for (var i = 0; i < response?.data?.data?.result.length;  i ++) {
          forecast_redeem_value_array.push(response?.data?.data?.result[i].forecast_redeem_value);
        }


        for (var i = 0; i < response?.data?.data?.result.length; i ++) {
          year_array.push(toFarsiNumber(response?.data?.data?.result[i].term_year));
        }


        this.setState({
          data: {
            labels: year_array,
            family: "Peyda",


            datasets: [
              {

                label: 'رشد پیش بینی شده ',
                data: forecast_redeem_value_array,
                fill: {

                },
                borderColor: "#00AA5B",
              },
              {

                data: guaranteed_reserve_array,
                label: 'رشد تضمینی  ',
                // fill: false,
                borderColor: "#155a9e",
                fill: {

                },
                // backgroundColor:"gradient"
              }

            ]

          },
          options: {
            elements: {
              line: {
                tension: 0.5,
              },
            },
            plugins: {

              // tooltips: {
              //   // callbacks: {
              //   //   title: function(tooltipItem:any, data:any) {
              //   //     return data['labels'][tooltipItem[0]['index']];
              //   //   },
              //   //   label: function(tooltipItem:any, data:any) {
              //   //     return data['datasets'][0]['data'][tooltipItem['index']];
              //   //   },
              //   //   afterLabel: function(tooltipItem:any, data:any) {
              //   //     var dataset = data['datasets'][0];
              //   //     var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
              //   //     return '(' + percent + '%)';
              //   //   }
              //   // },
              //   backgroundColor: '#FFF',
              //   titleFontSize: 16,
              //   titleFontColor: '#0066ff',
              //   bodyFontColor: '#000',
              //   bodyFontSize: 14,
              //   displayColors: false
              // },
              tooltip: {
                backgroundColor: '#ffffff',
                titleFontSize: 16,
                bodyFontColor: '#000000',
                titleFontColor:'#000000',
                titleColor:'#000000',
                bodyFontSize: 14,
                bodyColor:"#000000",
                displayColors: false,
                borderColor:'rgba(0, 0, 0, 0)',
                bodyFont: {
                  family: "Peyda",

                },
                titleFont: {
                  family: "Peyda",

                },
                rtl:true,
                
                callbacks: {
                  // backgroundC
                borderColor:'rgba(0, 0, 0, 0)',
                  // titleFontSize: 16,
                  // titleFontColor: '#0066ff',
                  // bodyFontColor: '#000',
                  // bodyFontSize: 14,
                  // displayColors: false,
                  title: function(context:any) {
                  let title = 'سال';

                
                  if (context[0]?.parsed?.x !== null) {
                      title += toFarsiNumber(numberWithCommas(context[0]?.parsed?.x));
                  }
                  return title;
                  },
                  label: function (context: any) {


                    let label = context.dataset.label || '';

                    if (label) {
                      label += ': ';
                    }
                    if (context?.parsed?.y !== null) {
                      label += toFarsiNumber(numberWithCommas(context?.parsed?.y));
                    }
                    return label;
                  },
                }
              },
              legend: {
                display: false,
                font: {
                  family: "Peyda",
                  lineHeight: 2,
                  useBorderRadius: true,
                  borderRadius: 20,

                },
              }
            },
            scales: {
              // to remove the labels
              x: {
                ticks: {
                  font: {
                    family: "Peyda",
                    weight: 800,
                  },
                },
                // to remove the x-axis grid
                grid: {
                  drawBorder: false,
                  display: false,
                },
              },
              // to remove the y-axis labels
              y: {
                ticks: {
                  beginAtZero: true,
                  callback: function (value: any) {
                    return `${toFarsiNumber(numberWithCommas(value))}  `;
                  },

                  font: {
                    family: "Peyda",
                    weight: 800,
                  },
                },
                grid: {
                  drawBorder: false,
                  display: false,
                },
                // to remove the y-axis grid

              },

            }
          }
        })
        this.props.dispatch(isEqual(this.state.selfsame))

        this.props.dispatch(universalDataa(
          {
            contract_id,
      premium_annually,
      adjustment_coefficient_death_benefit,
      start_death_asset,
        universal_projects: null,

        holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
        insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),
        payment_method: 0,
        available_price: this.state.projectDetails?.available_price,
        unit_request: this.state.value,
        duration: this.state.projectDetails?.duration,
        policy_holder_job_category,
         insured_job_category,
  exemption_rate : 0,
  minimum_insurance_premium

          }
        ));


        //   // toast.success(response?.message);
      }

    } catch (err: any) {
   
      // this.setState({ error: err.inner })
    }
  };
findMinLimitation = (field: string) => {
  const { limitationInquiry } = this.state;
  let min = limitationInquiry.filter((item: { name: string; }) => item.name === field)[0]?.min;
  if (min) {
    return Number(min)
  } else {
    return Number(0)
  }
}
async checkForm() {
  const { premium_annually , adjustment_coefficient_death_benefit, start_death_asset , insured_birthday ,holder_birthday , insured_job_category , policy_holder_job_category} = this.state;
  const shebaCodeSchema = yup.object({
    holder_birthday: yup.string().required("تاریخ تولد اجباری می باشد"),
      policy_holder_job_category: yup.string().required("شغل اجباری می باشد"),
      insured_birthday: yup.string().required("تاریخ تولد اجباری می باشد"),
      insured_job_category: yup.string().required("شغل اجباری می باشد"),
   

    // premium_annually: yup.string().required("حق بیمه سال اول اجباری می باشد")
    //   .test("premium_annually", `حق بیمه سال اول نمیتواند کمتر از ${this.findMinLimitation("premium_annually")} ریال و بیشتر از ${this.findMaxLimitation("premium_annually")} ریال باشد `,
    //     (value) => {
    //       if (Number(value) < this.findMinLimitation("premium_annually") || Number(value) > this.findMaxLimitation("premium_annually")) {
    //         return false;
    //       } else {
    //         return true
    //       }

    //     }),

        adjustment_coefficient_death_benefit: yup.string()
        .required("ضریب تعدیل سرمایه فوت اجباری می باشد")
        .test("adjustment_coefficient_death_benefit", `  نمیتواند کمتر از ${this.findMinLimitation("adjustment_coefficient_death_benefit")} ریال و بیشتر از ${this.findMaxLimitation("adjustment_coefficient_death_benefit")} ریال باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("adjustment_coefficient_death_benefit") || Number(value) > this.findMaxLimitation("adjustment_coefficient_death_benefit")) {
              return false;
            } else {
              return true
            }

          }),


    start_death_asset: yup.string().required("مدت پرداخت حق بیمه اجباری می باشد")
      .test("start_death_asset", `  نمیتواند کمتر از ${this.findMinLimitation("start_death_asset")}  و بیشتر از ${this.findMaxLimitation("start_death_asset")}  باشد `,
        (value) => {
          if (Number(value) < this.findMinLimitation("start_death_asset") || Number(value) > this.findMaxLimitation("start_death_asset")) {
            return false;
          } else {
            return true
          }

        })


  });
  try {

    await shebaCodeSchema.validate({ holder_birthday , policy_holder_job_category , insured_birthday , insured_job_category ,  adjustment_coefficient_death_benefit, start_death_asset }, { abortEarly: false });
   

      this.createInquery();
    
    this.setState({ errors: [] })


  } catch (err: any) {
    this.setState({ errors: err.inner })
  }
};
findMaxLimitation = (field: string) => {
  const { limitationInquiry } = this.state;
  // let max = limitationInquiry.find((el: { [x: string]: any; }) => el[field])?.max;
  let max = limitationInquiry.filter((item: { name: string; }) => item.name === field)[0]?.max
  if (max) {
    return Number(max)
  } else {
    return Number(10000000000)
  }
}

handleChangeHolderBD = (value: any) => {
  this.setState({ holder_birthday: value })
  if (this.state.selfsame) {
    this.setState({
      insured_birthday: value,
    })
  }
};
handleChangeInsuredBD = (value: any) => {
  this.setState({ insured_birthday: value })
  if (this.state.selfsame) {
    this.setState({
      holder_birthday: value,
    })
  }

};
changeJobInsured = (e: any) => {
  this.setState({ insured_job_category: e.value, insured_job_category_title: e.title })
  if (this.state.selfsame) {
    this.setState({
      policy_holder_job_category: e.value,
      policy_holder_job_category_title: e.title,

    })
  }

}
changeJobHolder = (e: any) => {
  this.setState({ policy_holder_job_category: e.value, policy_holder_job_category_title: e.title })


  if (this.state.selfsame) {
    this.setState({


      insured_job_category: e.value,
      insured_job_category_title: e.title,


    })
  }

}
async downloadPdf() {
  this.setState({ base64Loading: true });
  const {
    contract_id,
    premium_annually,
    adjustment_coefficient_death_benefit,
    start_death_asset,
insured_birthday,
holder_birthday,
policy_holder_job_category, insured_job_category
  } = this.state;
  try {

    const response = await axios.post(
      `${AppConstants.base_url_api}universalHousingOfferreport`,
      {
        premium_annually,
  adjustment_coefficient_death_benefit,
  start_death_asset,
  exemption_rate:0,
          contract_id,
          holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
          insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),
          payment_method: 0,
          available_price: this.state.projectDetails?.available_price,
          unit_request: this.state.value,
          duration: this.state.projectDetails?.duration,
          policy_holder_job_category,
           insured_job_category
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization:  `${Cookies.get('acto')}`,
        },
        responseType: "blob", 
      }
    );
    if (response) {
    

    this.setState({ base64Loading: false })
    try {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  // this.setState({ base64Data: url })
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "report.pdf"); // نام فایل
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
    } catch (error) {
      console.error("خطایی رخ داد:", error   );
      this.setState({ base64Loading: false })
    } 
    }
  } catch (err: any) {
 
  }
};
universaHousingContractList = async () => {
  // this.setState({ contentLoading: true })

  try {

    const response = await service.limitationInquiry.universaHousingContractList(window.location.pathname.split("/")[2]);
    if (response) {
      this.setState({ contractList: response?.data?.data?.data?.list})
    }
  } catch (error: any) {
    if (error && error.status) {
      // this.setState({ contentLoading: false })
    }
  }
};
   getDefaultInquery = async (isEdit?:boolean) => {
      this.setState({ contentLoading: true })
  
      try {
  
        const contractId = window.location.pathname.split("/")[2];
        let response;
    
        if (contractId) {
          response = await service.limitationInquiry.inqueryDefault(contractId);
          if (response) {
            
  
  
          const  defaults = response.data.data?.data;
          const data = defaults?.contract_anually
            ? defaults.defaults_anually
            : defaults.defaults_once;

         

            const findDefault = (name:string) => data.filter((item:any) => item.name === name)[0]?.default;
           
            this.setState({
              // return response;
              limitationInquiry: data,
              allLimitationInquiry:response.data.data?.data,
              contract_id: defaults?.contract_anually
              ? defaults.contract_anually
              : defaults?.contract_once_id,
              // return response;
              selfsame:findDefault("insuredEqualPolicyHolder"),
              adjustment_coefficient_death_benefit: findDefault("adjustment_coefficient_death_benefit"),
    
              holder_birthday: parsePersianDate(findDefault("policy_holder_birth_date")) || "",
              insured_birthday: parsePersianDate(findDefault("insured_birth_date")),
  
              policy_holder_job_category: findDefault("policy_holder_job")?.id || "",
              policy_holder_job_category_title: findDefault("policy_holder_job")?.job_title || "",
  
              
              insured_job_category: findDefault("insured_job")?.id || "",
              insured_job_category_title: findDefault("insured_job")?.job_title || "",
              premium_annually: findDefault("premium_annually"),
              start_death_asset: findDefault("start_death_asset"),

  
              value: findDefault("unit_count"),
              minimum_insurance_premium:findDefault("minimum_insurance_premium"),
    
            }, async () => {
              
              await this.getDetails(findDefault("projects")[0]?.value);
              await this.getMoreDetails(findDefault("projects")[0]?.value);
            
            
            })

          }

        }
    } catch (error:any) {
      this.setState({ contentLoading: false })
      if(error?.status === 400){
        toast.error("قرارداد یافت نشد")
      }
      // throw error;
    }
  };
  handleChange = (event:any, newValue:number) => {
    this.setState({ tabValue: newValue });
  };
  calculateDateProgress = (startDateStr: string, endDateStr: string): number => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format");
      return 0;
    }
    const totalDays = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
    if (totalDays <= 0) return 0; // جلوگیری از تقسیم بر صفر
    const passedDays = (today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
    const progressPercentage = (passedDays / totalDays) * 100;
    const finalValue = Math.min(Math.max(progressPercentage, 0), 100);
    return Number(finalValue.toFixed(2));
  };
  
  

  calculateInvestmentAmount = (meterage: number) => {
    return meterage * this.state.projectDetails?.available_price;
  };

  isValidMeterage = (value: string): boolean => {
    if (value === "") return true;
    if (!/^\d*\.?\d{0,8}$/.test(value)) return false;
    if ((value.match(/\./g) || []).length > 1) return false;
    
    const numValue = Number(value);
    return !isNaN(numValue) && numValue >= 0.1 && numValue <= this.state.projectDetails?.available_quantity;
  };

  handleMeterageChange = (value: string) => {
    const max = this.state.projectDetails?.available_quantity;
  
    if (/^\d*\.?\d*$/.test(value) || value === "") {
      let numericValue = Number(value);
  
      // اگر بیشتر از max بود، محدودش کن
      if (numericValue > max) {
        numericValue = max;
        value = String(max);
      }
  
      this.setState({
        value,
        start_death_asset: value === "" ? "" : this.calculateInvestmentAmount(numericValue).toFixed(0),
        premium_annually: value === "" ? "" : this.calculateInvestmentAmount(numericValue).toFixed(0)
      });
    }
  };
  
  

  // handleMeterageBlur = () => {
  //   if (this.state.value === "") {
  //     this.setState({ 
  //       // value: "0.1",
  //       start_death_asset: this.calculateInvestmentAmount(0.1).toFixed(0),
  //       // premium_annually: this.calculateInvestmentAmount(0.1).toFixed(0)
  //     });
  //     return;
  //   }

  //   const numValue = Number(this.state.value);
  //   if (isNaN(numValue) || numValue < 0.1) {
  //     this.setState({ 
  //       // value: "0.1",
  //       start_death_asset: this.calculateInvestmentAmount(0.1).toFixed(0),
  //       // premium_annually: this.calculateInvestmentAmount(0.1).toFixed(0)
  //     });
  //   } else if (numValue > this.state.projectDetails?.available_quantity) {
  //     this.setState({ 
  //       value: this.state.projectDetails?.available_quantity.toString(),
  //       start_death_asset: this.calculateInvestmentAmount(this.state.projectDetails?.available_quantity).toFixed(0),
  //       // premium_annually: this.calculateInvestmentAmount(this.state.projectDetails?.available_quantity).toFixed(0)
  //     });
  //   } else {
  //     this.setState({ 
  //       value: numValue.toFixed(8),
  //       start_death_asset: this.calculateInvestmentAmount(numValue).toFixed(0),
  //       // premium_annually: this.calculateInvestmentAmount(numValue).toFixed(0)
  //     });
  //   }
  // };

  handleInvestmentChange = (value: string) => {
    if (/^\d*$/.test(value) || value === "") {
      const max = this.state.projectDetails?.available_quantity * this.state.projectDetails?.available_price;
      let numValue = Number(value);
  
      // کنترل محدودیت max
      if (numValue > max) {
        numValue = max;
        value = String(max);
      }
  
      this.setState({
        start_death_asset: value,
        premium_annually: value,
        value: value === "" ? "" : (numValue / this.state.projectDetails?.available_price).toFixed(8)
      });
    }
  };
  
  

  // handleInvestmentBlur = () => {
  //   if (Number(this.state.start_death_asset) === 0) {
  //     this.setState({ 
  //       start_death_asset: (0.1 * this.state.projectDetails?.available_price).toFixed(0),
  //       // premium_annually: (0.1 * this.state.projectDetails?.available_price).toFixed(0),
  //       // value: "0.1"
  //     });
  //     return;
  //   }

  //   const numValue = Number(this.state.start_death_asset);
  //   const maxValue = this.state.projectDetails?.available_quantity * this.state.projectDetails?.available_price;
    
  //   if (numValue < 0.1 * this.state.projectDetails?.available_price) {
  //     this.setState({ 
  //       start_death_asset: (0.1 * this.state.projectDetails?.available_price).toFixed(0),
  //       // premium_annually: (0.1 * this.state.projectDetails?.available_price).toFixed(0),
  //       // value: "0.1"
  //     });
  //   } else if (numValue > maxValue) {
  //     this.setState({ 
  //       start_death_asset: maxValue.toString(),
  //       // premium_annually: maxValue.toString(),
  //       value: this.state.projectDetails?.available_quantity.toString()
  //     });
  //   } else {
  //     const newMeterage = Number((numValue / this.state.projectDetails?.available_price).toFixed(8));
  //     this.setState({ value: newMeterage.toString() });
  //   }
  // };
  handleOpenModal = (label: string, notice: string) => {
    this.setState({
      openModal: true,
      modalLabel: label,
      modalNotice: notice
    });
  };

  handleCloseModal = () => {
    this.setState({
      openModal: false,
      modalLabel: "",
      modalNotice: ""
    });
    }
    changeContract = (event:any) => {
      const contractValue = event.target.value;
      const pathParts = window.location.pathname.split("/");

      this.setState({contract_id : contractValue}, () => {
      if (pathParts[1] === "universal-update") {
        this.getDefaultInquery();
    } else {
        this.getLimitationInquery();
    

    }
        });
      }
}
export default UniversalController;
